(function (angular, _) {
    var MyHippoProducerServices = angular.module('MyHippoProducer.Services');
    MyHippoProducerServices.factory('UserService', function ($log, AnalyticsService, $injector) {
        let currentUser;
        const userMethods = {
            init: (userData) => {
                currentUser = userData;
                $log.info('Initialized user data', userData);

                const producerId = _.get(userData, 'data.external_producer_id');
                const userId = producerId || _.get(userData, 'id');
                const roles = _.get(userData, 'data.roles');
                const hasRoles = roles && Object.keys(roles).length > 0;
                const userEmail = _.get(userData, 'email') || _.get(userData, 'data.email');
                const organizationName = _.get(userData, 'main_organization.name');

                AnalyticsService.setUserId(userId);

                const analyticsUserProperties = {
                    email: userEmail ? userEmail.toLowerCase() : '',
                    organization_id: userData.organization_id,
                    organization_name: organizationName ? organizationName.toLowerCase() : '',
                    parent_organization_id: userData.parent_organization_id,
                    producer_id: producerId,
                    is_producer: true,
                    user_id: userId,
                };

                if (hasRoles) {
                    analyticsUserProperties.roles = {
                        admin: !!roles.admin,
                        customerService: !!roles.customer_service,
                        masterAgent: !!roles.master_agent,
                        principal: !!roles.principal,
                    };
                }

                AnalyticsService.addUserProperties(analyticsUserProperties);

                const StradaService = $injector.get('StradaService');
                StradaService.initialize(userData, true);
            },
            getCurrentUser: () => currentUser,
            isPolicyCreationDisabled: () => _.get(currentUser, 'organization_policy_creation_disabled'),
            // Roles
            getRoles: () => _.get(currentUser, 'data.roles', {}),
            isAdmin: () => _.get(currentUser, 'data.roles.admin', false),
            isPrincipal: () => _.get(currentUser, 'data.roles.principal', false),
            isMasterAgent: () => _.get(currentUser, 'data.roles.master_agent', false),
            isCustomerService: () => _.get(currentUser, 'data.roles.customer_service', false),
            // User Data
            getName: () => _.get(currentUser, 'data.name', 'N/A'),
            getId: () => _.get(currentUser, 'id'),
            getOrgId: () => _.get(currentUser, 'organization_id'),
            getRootOrgId: () => _.get(currentUser, 'main_organization_id'),
            getParentOrgId: () => _.get(currentUser, 'parent_organization_id'),
            getEmail: () => _.get(currentUser, 'data.email'),
            showNewPolicyDesign: () => _.get(currentUser, 'data.show_new_policy_page', false),
            getUserSubOrganizations: () => _.get(currentUser, 'data.sub_organizations', []),
            getPartnerStyling: () => {
                // TODO: Hack to show toll brother logo
                const { subdomain } = _.get(currentUser, 'main_organization', {});
                if (subdomain === 'tollbrothers') {
                    return {
                        namme: 'tollbrothers',
                        logoUrl: 'img/tollbrothers.png'
                    };
                }
                return null;
            },
            getLastLogin: () => {
                const userLastLogin = _.get(currentUser, 'data.last_login', undefined);
                return Date.parse(userLastLogin);
            },
            isBuilder: () => _.get(currentUser, 'is_builder'),
        };

        // Permissions logic
        _.merge(userMethods, {
            canViewCreatedByFilter: () => userMethods.isAdmin() || userMethods.isPrincipal() || userMethods.isMasterAgent(),
            canEditProducers: () => userMethods.isAdmin() || userMethods.isPrincipal(),
            canEditOrganizations: () => userMethods.isPrincipal(),
            canViewOrgFromProfileDropdown: () => userMethods.isAdmin(),
            canViewAgentName: () => userMethods.isAdmin() || userMethods.isPrincipal() || userMethods.isMasterAgent(),
            canViewAdminPanel: () => userMethods.isAdmin() || userMethods.isPrincipal(),
        });

        return _.merge(userMethods, {
            getUser: () => ({
                disabledPolicyCreation: userMethods.isPolicyCreationDisabled(),
                isAdmin: userMethods.isAdmin(),
                isPrincipal: userMethods.isPrincipal(),
                name: userMethods.getName(),
                email: userMethods.getEmail(),
                id: userMethods.getId(),
                orgId: userMethods.getOrgId(),
                getLastLogin: userMethods.getLastLogin(),
            }),
        });
    });
})(window.angular, window._);
